import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import custom from '@/custom';
import codes from '@/codes';
import vSelect from 'vue-select';
import groupList from '../../Management/group/group.List.i18n'

//restful api
import { detect as integrity } from '@/service/api/integrity'

const default_opt = () => ({
  perPage: 10, //limit,
  currentPage: 1,
  totalRows: 0,
  target : "agent",
  cmd : "search",
  request : "wsf",
  offset : 0,
  limit : 10,
  adv : false,
  sk : '', "sv" : '', "skt" : '', "opt" : { },
  body : {
    sort : [ { name : "group_id" }, { name : "id", op : "desc" } ]
  }
})

const i18n_fields = {
  EN: [
    { key: 'id', label: '#', sortable: false, thStyle: 'width: 5%' },
    { key: 'created_at', label: 'Time', sortable: false, thStyle: 'width: 15%' },
    { key: 'type', label: 'Type', sortable: false, thStyle: 'width: 8%' },
    { key: 'action', label: 'Action', sortable: false, thStyle: 'width: 10%' },
    { key: 'target', label: 'Target', sortable: false },
  ],
  KO: [
    { key: 'id', label: '#.', sortable: false, thStyle: 'width: 5%' },
    { key: 'created_at', label: '등록일', sortable: false, thStyle: 'width: 15%' },
    { key: 'type', label: '분류', sortable: false, thStyle: 'width: 8%' },
    { key: 'action', label: '행위', sortable: false, thStyle: 'width: 10%' },
    { key: 'target', label: '대상', sortable: false },
  ]
}

export default {
  components: { DatePicker, vSelect, groupList },
  props: ['is_main'],
  data : () => {
    return {
      action_list : [],
      chainGroup : false,
      codes,
      moment,
      group_name : '',
      custom,
      sync : { th : undefined, stop : false, interval : 15, enable : false },
      summaryData : { enable : 0, disable : 0 },
      //
      view_html : false,
      so : default_opt(),
      selected : '',
      limit : 20,
      search_type : '',
      action_type : '',
      model : {},
      hide_del : true,
    }
  },
  computed: {
    rowCount: function() { return this.so.totalRows || 0; },
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      return i18n_fields[this.i18n];
    },
  },
  methods: {
    set_op(k, v, equal=false) {
      if(equal) {
        return { name : k, value : v, op : '=' }
      }
      else if(['level', 'mode', 'group_id'].indexOf(k) > -1) {
        // console.log({ name : k, value : parseInt(v, 10), op : '=' })
        return { name : k, value : parseInt(v, 10), op : '=' };
      } else if(v == 'false' || v == 'true') {
        return { name : k, value : v === "false" ? false : true, op : '=' }
      }

      return { name : k, value : `%${v}%`, op : 'like' }
    },
    setGroup(item) {
      console.log("group info", item.groupname, item.id)
      this.so.opt['group_id'] = item.id
      this.group_name = item.groupname;
      this.chainGroup = false;
      this.refresh()
    },
    clearChain(type) {
      if(!type) { return this.$toastr.w("require", "clear type") }
      switch (type) {
        case 'group':
          delete this.so.opt.group_id
          this.group_name = '';
          this.chainGroup = false;
          break;
        default:
          break;
      }
      this.refresh()
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['match_type'] = 'and';

        this.so.sv = '';
      } else { this.reset(); }
    },
    reset() { this.so = default_opt(); this.group_name = undefined; this.refresh(); },
    // save(item) {
    //   let snapshot = [[item.target, item.depth, item.hash_selected.value]]
    //   Api.Manager_Call({target: 'integrity', cmd : 'update', body : { id : item.forgery_id, snapshot : snapshot, site_id : item.site_id, group_id : item.group_id }})
    // },
    async getAction() {
      // let rs = await Api.Manager_Call('integrity.detect', 'action')
      let rs = await integrity.actionDetect()

      let result = []
      result = rs.body

      this.action_list = rs.total > 0 ? result.slice(1) : []
    },
    refresh() { console.log('refresh'); this.$refs._list.refresh(); },
    getItems(ctx) { return this.load(ctx); },
    async load(ctx = {}) {
      let so = {
        // target : 'integrity.detect', cmd : 'list',
        body : { sort : [{ name : "id", op : "desc"}], or : [], and : [] },
        offset : (this.so.currentPage-1 || 0) * this.limit, limit: this.limit, // 10 은 나중에 변수 처리해야함.
      }
      this.so.perPage = this.limit;
      // if(this.search_type != '') { and.push({ name : "type", value : this.search_type, op : "=" }); }
      // if(this.so.skt == 'action') { and.push({ name : "action", value : this.action_type, op : "=" }); }
      // if(and.length) { so.body.and = and; }

      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.so.sk && (this.so.sv || '').trim()) { so.body.and.push({ name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' }); }
      if(this.hide_del) { so.body.and.push({ name : 'is_del', value : false, op : '='}); }

      try {
        if(this.so.adv && this.so.opt) {
          var k = Object.keys(this.so.opt)
          for (let i = 0; i < k.length; i++) {
            if(k[i] == 'match_type') { continue; }
            let cond = undefined;

            switch (k[i]) {
              case 'created_at_sd':
                if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
                cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
                break;
              case 'created_at_ed':
                if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
                cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
                break;
              case 'updated_at_sd':
                if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
                cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
                break;
              case 'updated_at_ed':
                if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
                cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
                break;
              default:
                cond = this.set_op(k[i], this.so.opt[k[i]]);
                break;
            }
            if(cond.value == '%%' || cond.value === '') { continue; }
            if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
            else { so.body.or.push(cond) }
          }
        }
        this.getAction()
      } catch (e) { console.log(e) }
      return integrity.listDetect(so).then(rs => { this.so.totalRows = rs.total; this.model = rs.body; return rs.body; }).catch(e => console.log(e) );
    },
    async save() {
      if(!(this.model.title || '').trim()) { return this.$toastr.e('Title is required'); }
      if(!(this.model.content || '').trim()) { return this.$toastr.e('Content is required.'); }
      try {
        let check_id = '';
        check_id = this.model.id ? `${integrity.updateDetect(this.model)}` : `${integrity.insertDetect(this.model)}`;

        let rs = check_id;
        if(!rs.error) {
          this.$toastr.s('Saved.', this.$route.name);this.$emit('refresh'); this.cancel();
        } else {
          this.$toastr.s('Save', 'failed');
        }
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText) ; }
    },
    async detail(model) {
      console.log('result.vue', 'load item', model.id);
      try {
        let rs = await integrity.detailDetect({ id : model.id });
        if(!rs.error) {
          this.$toastr.i("loading", "done")
          this.model = rs.body;
        } else {
          this.$toastr.e("load failed", rs.reason)
        }

      } catch(e) { this.catch_msg(e) }
    },
    catch_msg(e) { console.log(e), this.$toastr.e(!e.data ? e : (e.data.message ? e.data.message : e.statusText)) },
    sv_reset(){
      if(this.so.sv != ''){
        this.so.sv = ''
        return this.so.sv
      }
    }
  },
  created() { console.log('result.vue', 'created'); this.$root.$on('select', this.setGroup); },
  destroyed() { console.log('result.vue', 'destroyed'); },
  mounted() { console.log('result.vue', 'mounted'); },
}